import { i18NextMixinFactory } from "@apphq/vue-base-components";

export const I18NextMixin = i18NextMixinFactory(
  "lib-vue-form",
  {
    en: {
      "keine Datei ausgewählt": "no file selected"
    }
  },
  "de"
);
